import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../routes/HomePage';
import CategoryPage from '../routes/CategoryPage';
import CategoryVideoPlay from '../routes/CategoryVideoPlay';
import SubscriptionPage from '../routes/SubscriptionPage';
import SubscriptionWaitingPage from '../routes/SubscriptionWaitingPage';
import LoginPage from '../routes/LoginPage';
import ProtectedRoute from '../components/ProtectedRoute';

const Routing = () => {
    const router=createBrowserRouter([{
        path:"/",
        element:<HomePage />
    },
    {
        path:"/subscribe",
        element:<SubscriptionPage />
    },
    {
        path:"/subscribe/waiting",
        element:<SubscriptionWaitingPage />
    },
    {
        path:"/login",
        element:<LoginPage />
    },
    {
        path:"/category/:category_name",
        element:(
            <ProtectedRoute>
                <CategoryPage />
            </ProtectedRoute>
        )
    },
    {
        path:"/category/video/play",
        element:(
            <ProtectedRoute>
                <CategoryVideoPlay />
            </ProtectedRoute>
        )
    },
    {
        path:"*",
        element:<Navigate to={"/"} />
    }
])
  
    return (
    <RouterProvider router={
        router
    } />
  )
}

export default Routing
